"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DesignThemeEnum = void 0;
var DesignThemeEnum;
(function (DesignThemeEnum) {
    DesignThemeEnum["LightGrey"] = "lightgrey";
    DesignThemeEnum["Grey"] = "grey";
    DesignThemeEnum["Dark"] = "dark";
})(DesignThemeEnum || (exports.DesignThemeEnum = DesignThemeEnum = {}));
//# sourceMappingURL=DesignThemeEnum.js.map